// src/pages/Guild.js (길드 둘러보기 오류 수정)
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { 
  collection, 
  query, 
  where, 
  getDocs, 
  addDoc, 
  updateDoc, 
  doc, 
  deleteDoc,
  serverTimestamp 
} from "firebase/firestore";
import GuildHeader from "./GuildHeader";
import GuildBoard from "./GuildBoard";
import GuildChat from "./GuildChat";
import GuildRanking from "./GuildRanking";
import GuildFriendly from "./GuildFriendly";
import GuildCreation from "./GuildCreation";
import GuildList from "./GuildList";
import GuildMemberManagement from "./GuildMemberManagement";
import GuildFinance from "./GuildFinance";
import { guildDataService } from "./GuildDataService";
// 기존 import에 추가
import GuildLogo from "./GuildLogo";
import GuildHashtags from "./GuildHashtags";
import GuildCard from "./GuildCard";

// 새로운 탭 구성 (길드 대전 추가)
const MEMBER_TABS = ["길드 소개", "멤버", "게시판", "채팅", "길드 이벤트"];
const LEADER_TABS = ["길드 소개", "멤버", "게시판", "채팅", "길드 이벤트", "길드 대전", "친선전", "회계"];

function Guild() {
  const navigate = useNavigate();
  const [localUser] = useState(() => JSON.parse(localStorage.getItem("user")));
  const [myGuild, setMyGuild] = useState(null);
  const [guildMembers, setGuildMembers] = useState([]);
  const [allGuilds, setAllGuilds] = useState([]);
  const [tab, setTab] = useState("길드 소개");
  const [creating, setCreating] = useState(false);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");
  
  // 길드 이벤트 관련 상태
  const [todayAttendance, setTodayAttendance] = useState(null);
  const [attendanceStreak, setAttendanceStreak] = useState(0);
  const [guildTournaments, setGuildTournaments] = useState([]);
  const [userPoints, setUserPoints] = useState(0);

  // 길드 대전 관련 상태
  const [guildMatchRequests, setGuildMatchRequests] = useState([]);
  const [matchModalOpen, setMatchModalOpen] = useState(false);
  const [selectedDates, setSelectedDates] = useState(['', '', '', '', '']);
  const [friendlyMatchModalOpen, setFriendlyMatchModalOpen] = useState(false);
  const [guildFriends, setGuildFriends] = useState([]);

  // 권한 확인
  const isLeader = myGuild?.leaderId === localUser?.id;
  const isSubLeader = localUser?.guildTier === "부길드장";
  const canManage = isLeader || isSubLeader;

  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [guildSearchQuery, setGuildSearchQuery] = useState("");
  const [guildSearchType, setGuildSearchType] = useState("name"); // name, hashtag, leader

  useEffect(() => {
    if (!localUser?.id) {
      setLoading(false);
      return;
    }
    fetchMyGuild();
  }, [localUser?.id]);

  const fetchMyGuild = async () => {
    if (!localUser?.id) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      console.log("🔍 길드 정보 조회 시작:", localUser.id);
      
      const guildData = await guildDataService.getMyGuild(localUser.id);
      console.log("📋 길드 조회 결과:", guildData);
      
      if (guildData) {
        setMyGuild(guildData.guild);
        setGuildMembers(guildData.members);
        console.log("✅ 길드 정보 설정 완료:", guildData.guild.name);
        
        // 길드 이벤트 데이터 로드
        await loadGuildEventData(guildData.guild.id);
        
        // 길드 대전 데이터 로드 (길드장만)
        if (guildData.guild.leaderId === localUser.id) {
          await loadGuildMatchData(guildData.guild.id);
        }
      } else {
        console.log("❌ 길드 정보 없음");
      }
      
      // 전체 길드 목록 로드 (안전하게)
      await loadAllGuilds();
      
    } catch (error) {
      console.error("길드 정보 로드 실패:", error);
      setMsg("길드 정보를 불러오는데 실패했습니다: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // 전체 길드 목록 로드 함수 (별도 분리)
  const loadAllGuilds = async () => {
    try {
      console.log("🔍 전체 길드 목록 로드 시작");
      
      // 직접 Firebase에서 길드 목록 가져오기
      const guildsSnap = await getDocs(collection(db, "guilds"));
      const guildsData = guildsSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // 각 길드의 멤버 수 계산
      const guildMembersSnap = await getDocs(collection(db, "guildMembers"));
      const memberCounts = {};
      
      guildMembersSnap.docs.forEach(doc => {
        const memberData = doc.data();
        if (memberData.guildId) {
          memberCounts[memberData.guildId] = (memberCounts[memberData.guildId] || 0) + 1;
        }
      });

      // 길드에 멤버 수 추가
      const guildsWithMemberCount = guildsData.map(guild => ({
        ...guild,
        memberCount: memberCounts[guild.id] || 0
      }));

      console.log("📋 전체 길드 목록 로드 완료:", guildsWithMemberCount.length);
      setAllGuilds(guildsWithMemberCount);
      
    } catch (error) {
      console.error("전체 길드 목록 로드 실패:", error);
      setAllGuilds([]); // 오류 시 빈 배열로 설정
    }
  };

  // 길드 이벤트 데이터 로드
  const loadGuildEventData = async (guildId) => {
    try {
      // 오늘 출석 체크 확인
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const attendanceQuery = query(
        collection(db, "guildAttendance"),
        where("guildId", "==", guildId),
        where("userId", "==", localUser.id),
        where("date", ">=", today)
      );
      const attendanceSnap = await getDocs(attendanceQuery);
      setTodayAttendance(!attendanceSnap.empty);
      
      // 연속 출석일 계산
      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const monthQuery = query(
        collection(db, "guildAttendance"),
        where("guildId", "==", guildId),
        where("userId", "==", localUser.id),
        where("date", ">=", monthStart)
      );
      const monthSnap = await getDocs(monthQuery);
      setAttendanceStreak(monthSnap.docs.length);
      
      // 사용자 포인트 로드
      setUserPoints(localUser?.guildPoints || 0);
    } catch (error) {
      console.error("길드 이벤트 데이터 로드 실패:", error);
    }
  };

  // 길드 대전 데이터 로드
  const loadGuildMatchData = async (guildId) => {
    try {
      // 길드 랭킹전 요청 목록
      const matchQuery = query(
        collection(db, "guildMatchRequests"),
        where("guildId", "==", guildId)
      );
      const matchSnap = await getDocs(matchQuery);
      setGuildMatchRequests(matchSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      // 친구 길드 목록
      const friendsQuery = query(
        collection(db, "guildFriends"),
        where("guildId", "==", guildId)
      );
      const friendsSnap = await getDocs(friendsQuery);
      setGuildFriends(friendsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error("길드 대전 데이터 로드 실패:", error);
    }
  };

  // 출석 체크 함수
  const handleAttendance = async () => {
    if (todayAttendance || !myGuild) {
      setMsg("이미 오늘 출석체크를 완료했습니다.");
      return;
    }

    try {
      await addDoc(collection(db, "guildAttendance"), {
        guildId: myGuild.id,
        userId: localUser.id,
        nickname: localUser.nickname,
        date: new Date(),
        points: 10,
        createdAt: serverTimestamp()
      });

      setTodayAttendance(true);
      setAttendanceStreak(prev => prev + 1);
      setUserPoints(prev => prev + 10);
      setMsg("출석체크 완료! 10 포인트를 획득했습니다.");
    } catch (error) {
      console.error("출석체크 실패:", error);
      setMsg("출석체크에 실패했습니다.");
    }
  };

  // 길드 랭킹전 신청
  const handleGuildRankingMatch = async () => {
    if (!isLeader) {
      setMsg("길드장만 랭킹전을 신청할 수 있습니다.");
      return;
    }

    const validDates = selectedDates.filter(date => date.trim());
    if (validDates.length !== 5) {
      setMsg("선호 날짜 5일을 모두 입력해주세요.");
      return;
    }

    try {
      await addDoc(collection(db, "guildMatchRequests"), {
        guildId: myGuild.id,
        guildName: myGuild.name,
        sport: myGuild.sport,
        region: myGuild.region,
        guildMMR: myGuild.guildMMR || 1000,
        preferredDates: validDates,
        status: "waiting",
        createdAt: serverTimestamp(),
        createdBy: localUser.id
      });

      setMatchModalOpen(false);
      setSelectedDates(['', '', '', '', '']);
      setMsg("길드 랭킹전 매칭이 신청되었습니다!");
      
      // 데이터 새로고침
      await loadGuildMatchData(myGuild.id);
    } catch (error) {
      console.error("길드 랭킹전 신청 실패:", error);
      setMsg("길드 랭킹전 신청에 실패했습니다.");
    }
  };

  // 길드 삭제 함수
  const handleDeleteGuild = async () => {
    if (!isLeader) {
      alert("길드장만 길드를 삭제할 수 있습니다.");
      return;
    }

    const confirmDelete = window.confirm(
      `정말로 "${myGuild.name}" 길드를 삭제하시겠습니까?\n\n이 작업은 되돌릴 수 없으며, 모든 길드 데이터가 영구적으로 삭제됩니다.`
    );

    if (!confirmDelete) return;

    const finalConfirm = window.prompt(
      `길드 삭제를 확인하려면 "${myGuild.name}"을 정확히 입력하세요:`
    );

    if (finalConfirm !== myGuild.name) {
      alert("길드명이 일치하지 않습니다.");
      return;
    }

    try {
      setLoading(true);
      console.log('길드 삭제 시작:', myGuild.id);
      
      // 1. 모든 길드 멤버의 길드 정보 제거
      const membersQuery = query(
        collection(db, "guildMembers"),
        where("guildId", "==", myGuild.id)
      );
      const membersSnap = await getDocs(membersQuery);
      
      for (const memberDoc of membersSnap.docs) {
        const memberData = memberDoc.data();
        // users 컬렉션에서 길드 정보 제거
        await updateDoc(doc(db, "users", memberData.userId), {
          guildId: null,
          guildName: null,
          guildTier: null,
          guildRole: null
        });
        // guildMembers 문서 삭제
        await deleteDoc(memberDoc.ref);
      }

      // 2. 길드 관련 데이터 삭제
      const collectionsToClean = [
        "guildAttendance",
        "guildMatches", 
        "guildPosts",
        "guildChats",
        "guildTournaments",
        "guildMatchRequests"
      ];

      for (const collectionName of collectionsToClean) {
        const dataQuery = query(
          collection(db, collectionName),
          where("guildId", "==", myGuild.id)
        );
        const dataSnap = await getDocs(dataQuery);
        
        for (const dataDoc of dataSnap.docs) {
          await deleteDoc(dataDoc.ref);
        }
      }

      // 3. 길드 문서 삭제
      await deleteDoc(doc(db, "guilds", myGuild.id));
      console.log('길드 문서 삭제 완료:', myGuild.id);

      alert("길드가 성공적으로 삭제되었습니다.");
      
      // 상태 초기화
      setMyGuild(null);
      setGuildMembers([]);
      setTab("길드 소개");
      navigate('/'); // 홈으로 이동
      
    } catch (error) {
      console.error("길드 삭제 실패:", error);
      alert("길드 삭제에 실패했습니다.\n" + error.message);
    } finally {
      setLoading(false);
    }
  };

  const getTierIcon = (mmr) => {
    if (mmr >= 2000) return "🔥";
    if (mmr >= 1800) return "💎";
    if (mmr >= 1600) return "🏆";
    if (mmr >= 1400) return "🥇";
    if (mmr >= 1200) return "🥈";
    return "🥉";
  };

  const getRoleColor = (guildTier) => {
    switch(guildTier) {
      case "길드장": return "#fbbf24";
      case "부길드장": return "#8b5cf6";
      case "정회원": return "#10b981";
      case "임시회원": return "#6b7280";
      default: return "#6b7280";
    }
  };

  const getOnlineStatus = (lastLogin) => {
    const now = new Date();
    const diff = now - lastLogin;
    const minutes = Math.floor(diff / (1000 * 60));
    
    if (minutes < 5) return { status: "온라인", color: "#10b981" };
    if (minutes < 60) return { status: `${minutes}분 전`, color: "#f59e0b" };
    if (minutes < 1440) return { status: `${Math.floor(minutes/60)}시간 전`, color: "#ef4444" };
    return { status: "오프라인", color: "#6b7280" };
  };

  // 길드 검색 필터링 함수
  const filteredGuilds = allGuilds.filter(guild => {
    // 이미 가입된 내 길드는 검색 결과에서 제외
    if (localUser.guildId && guild.id === localUser.guildId) return false;
    if (!guildSearchQuery.trim()) return true;
    const q = guildSearchQuery.trim().toLowerCase();
    if (guildSearchType === "name") {
      return guild.name && guild.name.toLowerCase().includes(q);
    }
    if (guildSearchType === "hashtag") {
      // 해시태그 배열에서 정확히 포함되는지, # 없이도 검색 가능하게
      return Array.isArray(guild.hashtags) && guild.hashtags.some(tag => tag.toLowerCase().replace('#','').includes(q.replace('#','')));
    }
    if (guildSearchType === "leader") {
      return guild.leaderName && guild.leaderName.toLowerCase().includes(q);
    }
    return true;
  });

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.loadingSpinner}></div>
        <div style={styles.loadingText}>길드 정보를 불러오는 중...</div>
      </div>
    );
  }

  if (creating) {
    return (
      <GuildCreation 
        currentUser={localUser}
        creating={creating}
        setCreating={setCreating}
        onGuildCreated={fetchMyGuild}
        onMessage={setMsg}
      />
    );
  }

  if (tab === "길드 찾기") {
    return (
      <GuildList 
        guilds={Array.isArray(allGuilds) ? allGuilds : []}
        currentUser={localUser}
        onBack={() => setTab("길드 소개")}
        onMessage={setMsg}
      />
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.maxWidth}>
        {/* 상단 헤더 오른쪽에 길드 찾기 버튼 */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
          <button
            onClick={() => setSearchModalOpen(true)}
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 12,
              padding: "10px 24px",
              fontWeight: 700,
              fontSize: 16,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(102,126,234,0.15)",
              transition: "all 0.2s"
            }}
          >
            🔍 길드 찾기
          </button>
        </div>
        {/* 길드 생성 버튼 (길드가 없을 때만 표시) */}
        {!myGuild && (
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
            <button
              onClick={() => {
                if (localUser.guildId) {
                  // 아무 동작도 하지 않음 (alert 제거)
                  return;
                }
                setCreating(true);
              }}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                padding: '10px 24px',
                fontWeight: 700,
                fontSize: 16,
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(102,126,234,0.15)',
                transition: 'all 0.2s'
              }}
            >
              🏰 길드 만들기
            </button>
          </div>
        )}
        {/* 경고문구 (길드가 없을 때만 표시) */}
        {!myGuild && !!localUser.guildId && (
          <div style={{ color: '#ef4444', fontWeight: 600, marginBottom: 16 }}>
            이미 길드에 가입되어 있어 새 길드를 만들 수 없습니다.
          </div>
        )}
        {myGuild ? (
          <>
            {/* 길드 헤더 (GuildHeader 컴포넌트로 교체) */}
            <GuildHeader
              guild={myGuild}
              members={guildMembers}
              currentUser={localUser}
              onUpdateGuild={setMyGuild}
            />

            {/* 탭 메뉴 */}
            <div style={styles.tabNavigation} className="glass-morphism">
              {(isLeader ? LEADER_TABS : MEMBER_TABS).map(tabName => (
                <button
                  key={tabName}
                  onClick={() => setTab(tabName)}
                  style={{
                    ...styles.tabButton,
                    ...(tab === tabName ? styles.activeTabButton : {})
                  }}
                >
                  {getTabIcon(tabName)} {tabName}
                </button>
              ))}
            </div>

            {/* 탭 콘텐츠 */}
            <div style={styles.tabContent} className="glass-morphism">
              {/* 길드 소개 탭 */}
              {tab === "길드 소개" && (
                <div>
                  <h3 style={styles.sectionTitle}>🏰 길드 개요</h3>
                  
                  <div style={styles.overviewGrid}>
                    <div style={styles.overviewCard}>
                      <div style={styles.cardIcon}>👑</div>
                      <div style={styles.cardLabel}>길드장</div>
                      <div style={styles.cardValue}>{myGuild.leaderName || "미설정"}</div>
                    </div>
                    
                    <div style={styles.overviewCard}>
                      <div style={styles.cardIcon}>🏆</div>
                      <div style={styles.cardLabel}>길드 점수</div>
                      <div style={styles.cardValue}>{myGuild.point || 0}점</div>
                    </div>
                    
                    <div style={styles.overviewCard}>
                      <div style={styles.cardIcon}>📈</div>
                      <div style={styles.cardLabel}>평균 MMR</div>
                      <div style={styles.cardValue}>
                        {guildMembers.length > 0 ? 
                          Math.round(guildMembers.reduce((sum, m) => sum + (m.mmr || 0), 0) / guildMembers.length) : 0}
                      </div>
                    </div>
                    
                    <div style={styles.overviewCard}>
                      <div style={styles.cardIcon}>👥</div>
                      <div style={styles.cardLabel}>활성 멤버</div>
                      <div style={styles.cardValue}>{guildMembers.length}명</div>
                    </div>
                  </div>

                  {/* 출석 체크 및 포인트 섹션 */}
                  <div style={styles.activitySection}>
                    <h4 style={styles.subsectionTitle}>🎯 길드 활동</h4>
                    
                    <div style={styles.activityGrid}>
                      <div style={styles.activityCard}>
                        <div style={styles.activityIcon}>🔥</div>
                        <div style={styles.activityLabel}>연속 출석</div>
                        <div style={styles.activityValue}>{attendanceStreak}일</div>
                      </div>
                      
                      <div style={styles.activityCard}>
                        <div style={styles.activityIcon}>⭐</div>
                        <div style={styles.activityLabel}>내 포인트</div>
                        <div style={styles.activityValue}>{userPoints}P</div>
                      </div>
                      
                      <div style={styles.activityCard}>
                        <div style={styles.activityIcon}>📅</div>
                        <div style={styles.activityLabel}>출석 현황</div>
                        <div style={{
                          ...styles.activityValue,
                          color: todayAttendance ? "#10b981" : "#f59e0b"
                        }}>
                          {todayAttendance ? "출석 완료" : "출석 대기"}
                        </div>
                        {!todayAttendance && (
                          <button onClick={handleAttendance} style={styles.attendanceButton}>
                            출석체크
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <div style={styles.rulesSection}>
                    <h4 style={styles.subsectionTitle}>📝 길드 목표 & 규칙</h4>
                    <p style={styles.rulesText}>
                      {myGuild.description || myGuild.intro || "설정된 길드 목표와 규칙이 없습니다. 길드장이 설정할 수 있습니다."}
                    </p>
                  </div>
                </div>
              )}

              {/* 멤버 탭 */}
              {tab === "멤버" && (
                <div>
                  <div style={styles.membersHeader}>
                    <h3 style={styles.sectionTitle}>👥 길드 멤버 ({guildMembers.length}명)</h3>
                    {canManage && (
                      <button
                        onClick={() => navigate(`/guild/${myGuild.id}/management`)}
                        style={styles.manageButton}
                      >
                        ⚙️ 멤버 관리
                      </button>
                    )}
                  </div>
                  
                  {guildMembers.length > 0 ? (
                    <div style={styles.membersTable}>
                      {/* 테이블 헤더 */}
                      <div style={styles.tableHeader}>
                        <div>상태</div>
                        <div>멤버 정보</div>
                        <div>등급</div>
                        <div>MMR</div>
                        <div>기여도</div>
                        <div>길드전 기록</div>
                        <div>최근 접속</div>
                      </div>
                      
                      {/* 멤버 목록 */}
                      {guildMembers.map((member, index) => {
                        const onlineStatus = getOnlineStatus(member.lastLogin || member.lastLoginDate || new Date());
                        return (
                          <div key={member.id} style={{
                            ...styles.tableRow,
                            backgroundColor: index % 2 === 0 ? "#fff" : "#f9fafb"
                          }}>
                            {/* 온라인 상태 */}
                            <div style={styles.statusColumn}>
                              <div style={{
                                ...styles.statusIndicator,
                                backgroundColor: onlineStatus.color
                              }}></div>
                            </div>
                            
                            {/* 멤버 정보 */}
                            <div style={styles.memberColumn}>
                              <div
                                style={styles.memberAvatar}
                                onClick={() => navigate(`/mypage/${member.userId || member.id}`)}
                              >
                                {member.profileImg ? (
                                  <img src={member.profileImg} alt="프로필" style={styles.avatarImg} />
                                ) : (
                                  <div style={styles.avatarPlaceholder}>👤</div>
                                )}
                              </div>
                              <div>
                                <div
                                  style={styles.memberName}
                                  onClick={() => navigate(`/mypage/${member.userId || member.id}`)}
                                >
                                  {member.nickname}
                                </div>
                                {member.guildRole && (
                                  <div style={styles.memberRole}>
                                    {member.guildRole}
                                  </div>
                                )}
                              </div>
                            </div>
                            
                            {/* 등급 */}
                            <div style={styles.tierColumn}>
                              <span style={{
                                ...styles.tierBadge,
                                backgroundColor: getRoleColor(member.guildTier)
                              }}>
                                {member.guildTier}
                              </span>
                            </div>
                            
                            {/* MMR */}
                            <div style={styles.mmrColumn}>
                              {getTierIcon(member.mmr || 0)} {member.mmr || 0}
                            </div>
                            
                            {/* 기여도 */}
                            <div style={styles.contributionColumn}>
                              {member.contribution || 0}
                            </div>
                            
                            {/* 길드전 기록 */}
                            <div style={styles.recordColumn}>
                              {member.guildWins || 0}승 {member.guildLosses || 0}패
                            </div>
                            
                            {/* 최근 접속 */}
                            <div style={{
                              ...styles.loginColumn,
                              color: onlineStatus.color
                            }}>
                              {onlineStatus.status}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div style={styles.emptyState}>
                      <div style={styles.emptyIcon}>👥</div>
                      <div style={styles.emptyTitle}>멤버가 없습니다</div>
                    </div>
                  )}
                </div>
              )}

              {/* 게시판 탭 */}
              {tab === "게시판" && (
                <GuildBoard 
                  guildId={myGuild.id} 
                  currentUser={localUser} 
                  guild={myGuild}
                />
              )}

              {/* 채팅 탭 */}
              {tab === "채팅" && (
                <GuildChat 
                  guildId={myGuild.id} 
                  localUser={localUser} 
                  guildMembers={guildMembers}
                />
              )}

              {/* 길드 이벤트 탭 */}
              {tab === "길드 이벤트" && (
                <div style={styles.comingSoonSection}>
                  <div style={styles.comingSoonIcon}>🎯</div>
                  <h4 style={styles.comingSoonTitle}>길드 이벤트</h4>
                  <p style={styles.comingSoonText}>
                    토너먼트, 출석체크, 길드 활동 등을 관리할 수 있습니다.
                  </p>
                  <button
                    onClick={() => navigate("/guild/events")}
                    style={styles.comingSoonButton}
                  >
                    이벤트 페이지로 이동
                  </button>
                </div>
              )}

              {/* 길드 대전 탭 */}
              {tab === "길드 대전" && isLeader && (
                <div>
                  <div style={styles.battleHeader}>
                    <h3 style={styles.sectionTitle}>⚔️ 길드 대전</h3>
                    <button
                      onClick={() => setMatchModalOpen(true)}
                      style={styles.battleButton}
                    >
                      ⚔️ 랭킹전 신청
                    </button>
                  </div>
                  
                  {/* 현재 매치 요청 상태 */}
                  <div style={styles.matchStatusSection}>
                    <h4 style={styles.subsectionTitle}>🎯 현재 매치 요청 상태</h4>
                    
                    {guildMatchRequests.length > 0 ? (
                      <div style={styles.matchRequestsList}>
                        {guildMatchRequests.map(request => (
                          <div key={request.id} style={styles.matchRequestCard}>
                            <div style={styles.requestHeader}>
                              <span style={styles.requestStatus}>
                                {request.status === 'waiting' ? '⏳ 매칭 대기중' : 
                                 request.status === 'matched' ? '✅ 매칭 완료' :
                                 '❌ 취소됨'}
                              </span>
                              <span style={styles.requestDate}>
                                {request.createdAt?.toDate().toLocaleDateString()}
                              </span>
                            </div>
                            <div style={styles.requestDates}>
                              <strong>선호 날짜:</strong> {request.preferredDates?.join(', ')}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={styles.noRequests}>
                        아직 신청한 매치가 없습니다.
                      </div>
                    )}
                  </div>

                  {/* 길드 대전 설명 */}
                  <div style={styles.battleInfoSection}>
                    <h4 style={styles.subsectionTitle}>ℹ️ 길드 대전 안내</h4>
                    <div style={styles.battleInfo}>
                      <div style={styles.infoItem}>
                        <span style={styles.infoIcon}>⚔️</span>
                        <div>
                          <div style={styles.infoTitle}>랭킹전</div>
                          <div style={styles.infoDesc}>같은 운동, 같은 지역의 길드와 자동 매칭</div>
                        </div>
                      </div>
                      <div style={styles.infoItem}>
                        <span style={styles.infoIcon}>📅</span>
                        <div>
                          <div style={styles.infoTitle}>선호 날짜</div>
                          <div style={styles.infoDesc}>5일의 선호 날짜를 입력하여 매칭 확률 증가</div>
                        </div>
                      </div>
                      <div style={styles.infoItem}>
                        <span style={styles.infoIcon}>🏆</span>
                        <div>
                          <div style={styles.infoTitle}>MMR 반영</div>
                          <div style={styles.infoDesc}>승부 결과에 따라 길드 MMR과 개인 MMR 변동</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* 친선전 탭 */}
              {tab === "친선전" && isLeader && (
                <GuildFriendly 
                  guildId={myGuild.id} 
                  currentUser={localUser} 
                  guild={myGuild}
                />
              )}

              {/* 회계 탭 */}
              {tab === "회계" && canManage && (
                <GuildFinance 
                  guildId={myGuild.id} 
                  currentUser={localUser} 
                  guild={myGuild}
                  canEdit={isLeader || isSubLeader}
                />
              )}
            </div>

            {/* 길드 랭킹전 신청 모달 */}
            {matchModalOpen && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContent}>
                  <h3 style={styles.modalTitle}>⚔️ 길드 랭킹전 신청</h3>
                  
                  <div style={styles.modalInfo}>
                    <p>같은 운동 종목과 지역의 길드와 매칭됩니다.</p>
                    <p><strong>운동:</strong> {myGuild.sport}</p>
                    <p><strong>지역:</strong> {myGuild.region}</p>
                  </div>

                  <div style={styles.datesSection}>
                    <h4 style={styles.datesTitle}>선호 날짜 5일 선택</h4>
                    {selectedDates.map((date, index) => (
                      <div key={index} style={styles.dateInput}>
                        <label style={styles.dateLabel}>날짜 {index + 1}:</label>
                        <input
                          type="date"
                          value={date}
                          onChange={(e) => {
                            const newDates = [...selectedDates];
                            newDates[index] = e.target.value;
                            setSelectedDates(newDates);
                          }}
                          style={styles.dateField}
                          min={new Date().toISOString().split('T')[0]}
                        />
                      </div>
                    ))}
                  </div>

                  <div style={styles.modalActions}>
                    <button
                      onClick={() => {
                        setMatchModalOpen(false);
                        setSelectedDates(['', '', '', '', '']);
                      }}
                      style={styles.cancelButton}
                    >
                      취소
                    </button>
                    <button
                      onClick={handleGuildRankingMatch}
                      style={styles.submitButton}
                    >
                      매칭 신청
                    </button>
                  </div>
                </div>
              </div>
            )}

            {msg && (
              <div style={styles.messageBar}>
                {msg}
              </div>
            )}
          </>
        ) : (
          /* 길드 없는 상태 */
          <div style={styles.noGuildSection}>
            <div style={styles.noGuildIcon}>🏰</div>
            <h2 style={styles.noGuildTitle}>길드에 참여하세요!</h2>
            <p style={styles.noGuildSubtitle}>
              같은 취미를 가진 사람들과 함께 활동하고 경쟁해보세요
            </p>
            
            <div style={styles.actionCards}>
              <div style={styles.actionCard}>
                <div style={styles.actionIcon}>⚡</div>
                <h3 style={styles.actionTitle}>새 길드 만들기</h3>
                <p style={styles.actionDesc}>나만의 길드를 만들어 리더가 되어보세요</p>
                <button onClick={() => setCreating(true)} style={styles.primaryActionButton}>
                  길드 생성하기
                </button>
              </div>
              
              <div style={styles.actionCard}>
                <div style={styles.actionIcon}>🔍</div>
                <h3 style={styles.actionTitle}>기존 길드 찾기</h3>
                <p style={styles.actionDesc}>활동 중인 길드에 가입 신청해보세요</p>
                <button onClick={() => setTab("길드 찾기")} style={styles.secondaryActionButton}>
                  길드 둘러보기
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 길드 검색 모달 */}
        {searchModalOpen && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.45)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <div style={{
              background: "#fff",
              borderRadius: 20,
              padding: 32,
              width: "100%",
              maxWidth: 700,
              maxHeight: "70vh",
              overflowY: "auto",
              boxShadow: "0 8px 32px rgba(102,126,234,0.15)"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
                <h2 style={{ fontSize: 22, fontWeight: 800, color: "#3730a3", margin: 0 }}>길드 검색</h2>
                <button
                  onClick={() => setSearchModalOpen(false)}
                  style={{
                    background: "#f3f4f6",
                    border: "none",
                    borderRadius: "50%",
                    width: 36,
                    height: 36,
                    fontSize: 20,
                    color: "#64748b",
                    cursor: "pointer"
                  }}
                  title="닫기"
                >
                  ×
                </button>
              </div>
              <GuildList
                guilds={filteredGuilds}
                currentUser={localUser}
                onBack={() => setSearchModalOpen(false)}
                onMessage={setMsg}
                searchType={guildSearchType}
                setSearchType={setGuildSearchType}
                searchQuery={guildSearchQuery}
                setSearchQuery={setGuildSearchQuery}
              />
            </div>
          </div>
        )}
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          .glass-morphism {
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(20px);
            border: 1px solid rgba(255, 255, 255, 0.3);
          }
          
          .pulse-effect {
            animation: pulse 2s infinite;
          }
          
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
          }
        `}
      </style>
      <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', zIndex: 9999 }}>
        <button onClick={() => window.location.href = '/'} style={{ padding: '16px 40px', borderRadius: 24, background: '#10b981', color: '#fff', fontWeight: 800, fontSize: 20, border: 'none', cursor: 'pointer', boxShadow: '0 4px 16px #10b98133', letterSpacing: 1 }}>
          홈 화면으로 이동
        </button>
      </div>
    </div>
  );
}

// 탭 아이콘 함수
function getTabIcon(tabName) {
  const icons = {
    "길드 소개": "🏰",
    "멤버": "👥",
    "게시판": "📝",
    "채팅": "💬",
    "길드 이벤트": "🎯",
    "길드 대전": "⚔️",
    "친선전": "🤝",
    "회계": "💰"
  };
  return icons[tabName] || "";
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    padding: "20px 0",
    color: "#1f2937"
  },
  maxWidth: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 20px"
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#fff",
    fontSize: 18,
    fontWeight: 600
  },
  loadingSpinner: {
    width: 50,
    height: 50,
    border: "4px solid rgba(255,255,255,0.3)",
    borderTop: "4px solid #fff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: 20
  },
  loadingText: {
    fontSize: 16
  },

  // 길드 헤더
  guildHeader: {
    borderRadius: 24,
    padding: 40,
    marginBottom: 24,
    color: "#1f2937"
  },
  guildHeaderContent: {
    textAlign: "center"
  },
  guildAvatarSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 24,
    marginBottom: 20,
    flexWrap: "wrap"
  },
  guildAvatar: {
    width: 100,
    height: 100,
    borderRadius: "50%",
    border: "4px solid rgba(255,255,255,0.3)",
    overflow: "hidden",
    flexShrink: 0
  },
  guildAvatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  guildAvatarPlaceholder: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #fbbf24, #f59e0b)",
    color: "#fff",
    fontSize: 48,
    fontWeight: 700
  },
  guildBasicInfo: {
    textAlign: "left",
    flex: 1,
    minWidth: 300
  },
  guildName: {
    fontSize: 42,
    fontWeight: 900,
    margin: "0 0 8px 0",
    textShadow: "2px 2px 4px rgba(0,0,0,0.1)"
  },
  guildMeta: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    fontSize: 16,
    opacity: 0.9,
    flexWrap: "wrap"
  },
  guildSportBadge: {
    background: "rgba(255,255,255,0.2)",
    padding: "4px 12px",
    borderRadius: 20,
    fontWeight: 600
  },
  guildRegion: {
    fontWeight: 500
  },
  guildMembers: {
    fontWeight: 500
  },
  guildPoints: {
    fontWeight: 600,
    color: "#10b981"
  },
  guildDescription: {
    fontSize: 18,
    margin: "20px 0",
    opacity: 0.9,
    lineHeight: 1.6
  },
  guildActions: {
    marginTop: 20,
    textAlign: "right"
  },
  deleteButton: {
    background: "rgba(239, 68, 68, 0.8)",
    color: "#fff",
    border: "2px solid rgba(239, 68, 68, 0.6)",
    borderRadius: 12,
    padding: "10px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.3s ease",
    backdropFilter: "blur(10px)"
  },

  // 탭 네비게이션
  tabNavigation: {
    display: "flex",
    gap: 8,
    marginBottom: 24,
    borderRadius: 16,
    padding: 8,
    overflowX: "auto"
  },
  tabButton: {
    flex: "0 0 auto",
    background: "transparent",
    color: "#6b7280",
    border: "none",
    borderRadius: 12,
    padding: "12px 20px",
    fontSize: 16,
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap"
  },
  activeTabButton: {
    background: "rgba(255,255,255,0.3)",
    color: "#1f2937",
    boxShadow: "0 2px 8px rgba(255,255,255,0.1)"
  },

  // 탭 콘텐츠
  tabContent: {
    borderRadius: 24,
    padding: 32,
    minHeight: 500
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: 800,
    color: "#1f2937",
    marginBottom: 24,
    display: "flex",
    alignItems: "center",
    gap: 12
  },
  subsectionTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#374151",
    marginBottom: 16,
    display: "flex",
    alignItems: "center",
    gap: 8
  },

  // 길드 소개 탭 스타일
  overviewGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: 24,
    marginBottom: 32
  },
  overviewCard: {
    background: "linear-gradient(135deg, #f8fafc, #e2e8f0)",
    color: "#1f2937",
    padding: 24,
    borderRadius: 16,
    textAlign: "center",
    border: "1px solid rgba(0,0,0,0.1)"
  },
  cardIcon: {
    fontSize: 32,
    marginBottom: 8
  },
  cardLabel: {
    fontSize: 14,
    opacity: 0.7,
    marginBottom: 5
  },
  cardValue: {
    fontSize: 20,
    fontWeight: 700
  },
  activitySection: {
    background: "#f8fafc",
    padding: 24,
    borderRadius: 16,
    border: "1px solid #e2e8f0",
    marginBottom: 24
  },
  activityGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: 16
  },
  activityCard: {
    background: "#fff",
    padding: 16,
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    textAlign: "center"
  },
  activityIcon: {
    fontSize: 24,
    marginBottom: 8
  },
  activityLabel: {
    fontSize: 14,
    color: "#6b7280",
    marginBottom: 4
  },
  activityValue: {
    fontSize: 16,
    fontWeight: 600,
    color: "#1f2937"
  },
  attendanceButton: {
    marginTop: 8,
    background: "linear-gradient(135deg, #10b981, #059669)",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "6px 12px",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer"
  },
  rulesSection: {
    background: "#f8fafc",
    padding: 24,
    borderRadius: 16,
    border: "1px solid #e2e8f0"
  },
  rulesText: {
    color: "#6b7280",
    lineHeight: 1.6,
    margin: 0
  },

  // 멤버 탭 스타일
  membersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 16
  },
  manageButton: {
    background: "linear-gradient(135deg, #6366f1, #4f46e5)",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    padding: "10px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer"
  },
  membersTable: {
    background: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    border: "1px solid #e5e7eb"
  },
  tableHeader: {
    display: "grid",
    gridTemplateColumns: "60px 1fr 100px 80px 80px 120px 120px",
    background: "linear-gradient(135deg, #f3f4f6, #e5e7eb)",
    padding: "16px 20px",
    fontWeight: 700,
    fontSize: 14,
    color: "#374151",
    borderBottom: "1px solid #e5e7eb"
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "60px 1fr 100px 80px 80px 120px 120px",
    padding: "16px 20px",
    borderBottom: "1px solid #f1f5f9",
    alignItems: "center",
    transition: "all 0.2s ease",
    cursor: "default"
  },
  statusColumn: {
    display: "flex",
    justifyContent: "center"
  },
  statusIndicator: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    border: "2px solid #fff",
    boxShadow: "0 0 0 1px rgba(0,0,0,0.1)"
  },
  memberColumn: {
    display: "flex",
    alignItems: "center",
    gap: 12
  },
  memberAvatar: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    overflow: "hidden",
    cursor: "pointer",
    flexShrink: 0
  },
  avatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  avatarPlaceholder: {
    width: "100%",
    height: "100%",
    background: "linear-gradient(135deg, #667eea, #764ba2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 16,
    fontWeight: 600
  },
  memberName: {
    fontWeight: 600,
    color: "#1f2937",
    cursor: "pointer",
    transition: "color 0.2s ease"
  },
  memberRole: {
    fontSize: 12,
    color: "#6b7280"
  },
  tierColumn: {},
  tierBadge: {
    color: "#fff",
    padding: "4px 8px",
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600
  },
  mmrColumn: {
    fontWeight: 600,
    color: "#3b82f6"
  },
  contributionColumn: {
    fontWeight: 600,
    color: "#10b981"
  },
  recordColumn: {
    fontSize: 14,
    color: "#6b7280"
  },
  loginColumn: {
    fontSize: 12,
    fontWeight: 500
  },

  // 길드 대전 스타일
  battleHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 16
  },
  battleButton: {
    background: "linear-gradient(135deg, #ef4444, #dc2626)",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    padding: "12px 24px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer"
  },
  matchStatusSection: {
    background: "#f8fafc",
    padding: 24,
    borderRadius: 16,
    border: "1px solid #e2e8f0",
    marginBottom: 24
  },
  matchRequestsList: {
    display: "flex",
    flexDirection: "column",
    gap: 12
  },
  matchRequestCard: {
    background: "#fff",
    padding: 16,
    borderRadius: 12,
    border: "1px solid #e5e7eb"
  },
  requestHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8
  },
  requestStatus: {
    fontSize: 14,
    fontWeight: 600
  },
  requestDate: {
    fontSize: 12,
    color: "#6b7280"
  },
  requestDates: {
    fontSize: 14,
    color: "#374151"
  },
  noRequests: {
    textAlign: "center",
    color: "#6b7280",
    fontSize: 16,
    padding: 40
  },
  battleInfoSection: {
    background: "#f8fafc",
    padding: 24,
    borderRadius: 16,
    border: "1px solid #e2e8f0"
  },
  battleInfo: {
    display: "flex",
    flexDirection: "column",
    gap: 16
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: 16,
    background: "#fff",
    borderRadius: 12,
    border: "1px solid #e5e7eb"
  },
  infoIcon: {
    fontSize: 24,
    flexShrink: 0
  },
  infoTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#1f2937",
    marginBottom: 4
  },
  infoDesc: {
    fontSize: 14,
    color: "#6b7280"
  },

  // 모달 스타일
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: 20
  },
  modalContent: {
    background: "#fff",
    borderRadius: 16,
    padding: 32,
    width: "100%",
    maxWidth: 500,
    maxHeight: "80vh",
    overflowY: "auto"
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 24,
    textAlign: "center",
    color: "#1f2937"
  },
  modalInfo: {
    background: "#f8fafc",
    padding: 16,
    borderRadius: 12,
    marginBottom: 24,
    border: "1px solid #e2e8f0"
  },
  datesSection: {
    marginBottom: 24
  },
  datesTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 16,
    color: "#374151"
  },
  dateInput: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 12
  },
  dateLabel: {
    fontSize: 14,
    fontWeight: 500,
    minWidth: 70
  },
  dateField: {
    flex: 1,
    padding: 10,
    border: "1px solid #d1d5db",
    borderRadius: 8,
    fontSize: 14
  },
  modalActions: {
    display: "flex",
    gap: 12,
    justifyContent: "flex-end"
  },
  cancelButton: {
    padding: "12px 24px",
    background: "#6b7280",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 500
  },
  submitButton: {
    padding: "12px 24px",
    background: "linear-gradient(135deg, #ef4444, #dc2626)",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 500
  },

  // Coming Soon 스타일
  comingSoonSection: {
    textAlign: "center",
    padding: 60,
    color: "#6b7280"
  },
  comingSoonIcon: {
    fontSize: 48,
    marginBottom: 16
  },
  comingSoonTitle: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 12,
    color: "#374151"
  },
  comingSoonText: {
    marginBottom: 24
  },
  comingSoonButton: {
    background: "linear-gradient(135deg, #667eea, #764ba2)",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    padding: "12px 24px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer"
  },

  // 길드 없는 상태 스타일
  noGuildSection: {
    background: "rgba(255,255,255,0.95)",
    backdropFilter: "blur(20px)",
    borderRadius: 24,
    padding: 60,
    textAlign: "center",
    color: "#374151"
  },
  noGuildIcon: {
    fontSize: 80,
    marginBottom: 24
  },
  noGuildTitle: {
    fontSize: 32,
    fontWeight: 900,
    margin: "0 0 16px 0"
  },
  noGuildSubtitle: {
    fontSize: 18,
    color: "#6b7280",
    marginBottom: 40,
    lineHeight: 1.6
  },
  actionCards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: 32,
    maxWidth: 800,
    margin: "0 auto"
  },
  actionCard: {
    background: "#fff",
    padding: 32,
    borderRadius: 20,
    border: "1px solid #e5e7eb",
    transition: "all 0.3s ease"
  },
  actionIcon: {
    fontSize: 48,
    marginBottom: 16
  },
  actionTitle: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 12,
    color: "#1f2937"
  },
  actionDesc: {
    color: "#6b7280",
    marginBottom: 24,
    lineHeight: 1.5
  },
  primaryActionButton: {
    width: "100%",
    background: "linear-gradient(135deg, #667eea, #764ba2)",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    padding: "12px 24px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  secondaryActionButton: {
    width: "100%",
    background: "#fff",
    color: "#667eea",
    border: "2px solid #667eea",
    borderRadius: 12,
    padding: "12px 24px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease"
  },

  // 빈 상태
  emptyState: {
    textAlign: "center",
    padding: 60,
    color: "#9ca3af"
  },
  emptyIcon: {
    fontSize: 48,
    marginBottom: 16
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: 600
  },

  // 메시지 바
  messageBar: {
    background: "rgba(255,255,255,0.9)",
    color: "#374151",
    padding: 16,
    borderRadius: 12,
    marginTop: 16,
    textAlign: "center",
    fontWeight: 600
  }
};

export default Guild;